export const DEFAULT_INACTIVE_TIMEOUT = 60000;

// localStorage key of the stable per-device client id (TP-3863).
export const APP_CLIENT_ID_KEY = 'TristarGameClient_clientId';

// Operator (HUB88) bet rejection code for exceeding a wagering limit.
export const LIMIT_REACHED_ERROR_CODE = 'OP00021';

// Used when the config has no row for the player's currency.
export const DEFAULT_MIN_BET_AMOUNT = 10;
export const DEFAULT_MAX_BET_AMOUNT = 10000;
// Rejected: the balance won't cover the stake.
export const INSUFFICIENT_BALANCE_ERROR_CODE = 'OP00003';
// A roll already going through — what a double submit gets back.
export const ROLL_IN_PROGRESS_ERROR_CODE = 'B00026';
